import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalComponent } from 'src/app/components/common/modal/modal.component';

@Component({
  selector: 'app-inexperienced-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe, ModalComponent],
  templateUrl: './inexperienced-dialog.component.html',
  styleUrl: './inexperienced-dialog.component.scss',
})
export class InexperiencedDialogComponent {
  protected startTest = false;
  constructor(public activeModal: NgbActiveModal) {}

  protected handlePrimaryAction() {
    if (!this.startTest) {
      return;
    }
    this.activeModal.close(this.startTest);
  }

  protected handleSecondaryAction() {
    this.activeModal.close(false);
  }
}
